import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import {
  getShiftApi,
  getShiftListApi,
  gettripoptiondata,
  upadteTripReplaceDriverApi,
  updatetrip,
} from "../../../services/TransportService";
import { getShiftListSearchApi } from "../../../services/SearchService";
import { toast } from "react-toastify";
import Select from "react-select";

// --- Helper Functions ---
// const formatTo12Hour = (timeStr) => {
//   const [hour, minute] = timeStr.split(":").map(Number);
//   const ampm = hour >= 12 ? "PM" : "AM";
//   const hour12 = hour % 12 === 0 ? 12 : hour % 12;
//   return `${hour12}:${String(minute).padStart(2, "0")} ${ampm}`;
// };

// const addMinutes = (timeStr, minsToAdd) => {
//   const [hours, minutes] = timeStr.split(":").map(Number);
//   const date = new Date();
//   date.setHours(hours);
//   date.setMinutes(minutes + minsToAdd);
//   return date.toTimeString().slice(0, 5);
// };

// const isTimeWithinRange = (time, min, max) => {
//   console.log(time, min, max);
//   const [h, m] = time.split(":").map(Number);
//   const [minH, minM] = min.split(":").map(Number);
//   const [maxH, maxM] = max.split(":").map(Number);

//   const toMinutes = (h, m) => h * 60 + m;

//   const timeMins = toMinutes(h, m);
//   const minMins = toMinutes(minH, minM);
//   const maxMins = toMinutes(maxH, maxM);

//   return timeMins >= minMins && timeMins <= maxMins;
// };

const ReplaceDriverModal = ({
  modalopen,
  setModalopen,
  routeid,
  tripdata,
  end_time,
  handleListReload,
}) => {
  // const [timemsg, setTimemsg] = useState("");
  const [createtriploading, setCreatettriploading] = useState(false);
  const [triperrormsg, setTriperrormsg] = useState("");
  const [optionloading, setOptionloading] = useState(false);
  // const [showoption, setShowoption] = useState(false);
  // const [busoption, setBusoption] = useState([]);
  const [driveroption, setDriveroption] = useState([]);
  // const [selectedBus, setSelectedbus] = useState(null);
  const [selecteddriver, setSelecteddriver] = useState(null);
  // const [shiftoption, setShiftoption] = useState([]);
  // const [selecetdShift, setSelectedShift] = useState(null);
  // const [starttime, setStarttime] = useState("");
  // const [endtime, setEndtime] = useState("");
  // const [tripmode, setTripmode] = useState("");
  // const [timeConfirmed, setTimeConfirmed] = useState(false);
  // const [status, setStatus] = useState("");
  const [tripform, settripform] = useState({
    // trip_mode: "",
    // shift_id: "",
    // bus_id: "",
    // start_time: "",
    driver_id: "",
    // status: "",
    // description: "",
  });
  const [errorform, setErrorform] = useState({
    // trip_mode: "",
    // shift_id: "",
    // bus_id: "",
    // start_time: "",
    driver_id: "",
    // status: "",
    // description: "",
  });
  useEffect(()=>{
    settripform({...tripform,driver_id:selecteddriver?.value||""})
  },[selecteddriver])
  useEffect(() => {
    if (modalopen) {
      gettripoption();
    } else {
      resetForm();
    }
  }, [modalopen]);
  const gettripoption = () => {
    setOptionloading(true);
    gettripoptiondata(routeid, {
      shift_id: tripdata?.shift?.id || "",
      start_time: tripdata?.start_time?.slice(0, 5) || "",
      trip_mode: tripdata?.trip_mode || "",
      trip_id: tripdata?.id || "",
    })
      .then((res) => {
        // const busList = res?.data?.data?.available_buses || [];
        const driverList = res?.data?.data?.available_drivers || [];

        // const optionbus = busList.map((data) => ({
        //   label: data.number_plate,
        //   value: data.id,
        // }));
        const optiondriver = driverList.map((data) => ({
          label: data.name,
          value: data.id,
        }));

        // setBusoption(optionbus);

        // const matchedBus = optionbus.find((b) => b.value == tripdata?.bus?.id);
        setDriveroption(
          optiondriver.filter((d) => d.value != tripdata?.driver?.id)
        );

        // setSelectedbus(matchedBus || null);
        // settripform((prev) => ({
        //   ...prev,
        //   bus_id: matchedBus?.value || "",
        // }));
      })
      .catch((err) => console.log(err))
      .finally(() => setOptionloading(false));
  };
  // useEffect(() => {
  //   if (modalopen) {
  //     getShiftListApi()
  //       .then((res) => {
  //         const shiftList = res?.data || [];
  //         setShiftoption(shiftList);
  //         const selected = shiftList.find((d) => d?.id == tripdata?.shift?.id);
  //         if (selected) {
  //           setSelectedShift({ label: selected.name, value: selected.id });
  //         }

  //         const initialStartTime = tripdata?.start_time?.slice(0, 5) || "";
  //         const initialTripMode = tripdata?.trip_mode || "";

  //         setTimeConfirmed(!!tripdata?.start_time);
  //         setStarttime(initialStartTime);
  //         setEndtime(addMinutes(initialStartTime, 25));
  //         setTripmode(initialTripMode);

  //         settripform({
  //           start_time: initialStartTime,
  //           shift_id: selected?.id || "",
  //           bus_id: "",
  //           driver_id: "",
  //           trip_mode: initialTripMode,
  //         });
  //       })
  //       .catch((err) => console.log(err));
  //   } else {
  //     resettripform();
  //   }
  // }, [modalopen, tripdata]);

  // const gettripoption = () => {
  //   setOptionloading(true);
  //   gettripoptiondata(routeid, {
  //     shift_id: tripform.shift_id,
  //     start_time: tripform.start_time,
  //     trip_mode: tripform.trip_mode,
  //     trip_id: tripdata?.id || "",
  //   })
  //     .then((res) => {
  //       const busList = res?.data?.data?.available_buses || [];
  //       const driverList = res?.data?.data?.available_drivers || [];

  //       const optionbus = busList.map((data) => ({
  //         label: data.number_plate,
  //         value: data.id,
  //       }));
  //       const optiondriver = driverList.map((data) => ({
  //         label: data.name,
  //         value: data.id,
  //       }));

  //       setBusoption(optionbus);

  //       const matchedBus = optionbus.find((b) => b.value == tripdata?.bus?.id);
  //       setDriveroption(
  //         optiondriver.filter((d) => d.value != tripdata?.driver?.id)
  //       );

  //       setSelectedbus(matchedBus || null);
  //       settripform((prev) => ({
  //         ...prev,
  //         bus_id: matchedBus?.value || "",
  //       }));
  //     })
  //     .catch((err) => console.log(err))
  //     .finally(() => setOptionloading(false));
  // };

  // useEffect(() => {
  //   if (timeConfirmed && starttime && tripmode && selecetdShift) {
  //     gettripoption();
  //     setShowoption(true);
  //   } else {
  //     setBusoption([]);
  //     setDriveroption([]);
  //     setSelectedbus(null);
  //     setSelecteddriver(null);
  //     setShowoption(false);
  //   }
  // }, [starttime, tripmode, selecetdShift, timeConfirmed]);

  // useEffect(() => {
  //   settripform((prev) => ({
  //     ...prev,
  //     start_time: starttime || "",
  //     shift_id: selecetdShift?.value || "",
  //     bus_id: selectedBus?.value || "",
  //     driver_id: selecteddriver?.value || "",
  //   }));
  // }, [starttime, selecetdShift, selectedBus, selecteddriver]);

  // const resettripform = () => {
  //   setStatus("");
  //   setShiftoption([]);
  //   setDriveroption([]);
  //   setBusoption([]);
  //   setSelectedbus(null);
  //   setSelectedShift(null);
  //   setSelecteddriver(null);
  //   setStarttime("");
  //   setEndtime("");
  //   setTimemsg("");
  //   setTripmode("");
  //   setOptionloading(false);
  //   setTimeConfirmed(false);
  //   setTriperrormsg("");
  //   settripform({
  //     trip_mode: "",
  //     shift_id: "",
  //     bus_id: "",
  //     driver_id: "",
  //     start_time: "",
  //     status: "",
  //     description: "",
  //   });
  //   setErrorform({
  //     trip_mode: "",
  //     shift_id: "",
  //     bus_id: "",
  //     driver_id: "",
  //     start_time: "",
  //     status: "",
  //     description: "",
  //   });
  // };
  const resetForm = () => {
    setSelecteddriver(null);
    setDriveroption([]);
    // setStatus("");
    setTriperrormsg("");
    settripform({
      driver_id: "",
      // status: "",
      // description: "",
    });
    setErrorform({
      driver_id: "",
      // status: "",
      // description: "",
    });
  };
  const handletripform = () => {
    let valid = true;
    const error = {
      // trip_mode: "",
      // shift_id: "",
      // bus_id: "",
      // start_time: "",
      driver_id: "",
      // status: "",
      // description: "",
    };
    // if (!tripform?.trip_mode) {
    //   error.trip_mode = "Mandatory Field";
    //   valid = false;
    // }
    // if (!tripform?.shift_id) {
    //   error.shift_id = "Mandatory Field";
    //   valid = false;
    // }
    // if (!tripform?.bus_id) {
    //   error.bus_id = "Mandatory Field";
    //   valid = false;
    // }
    // if (!tripform?.start_time) {
    //   error.start_time = "Mandatory Field";
    //   valid = false;
    // }
    if (!tripform?.driver_id) {
      error.driver_id = "Mandatory Field";
      valid = false;
    }
    // if (!tripform?.status) {
    //   error.status = "Mandatory Field";
    //   valid = false;
    // }
    // if (!tripform?.description) {
    //   error.description = "Mandatory Field";
    //   valid = false;
    // }
    setErrorform(error);
    if (valid) {
      console.log(tripform);
        setCreatettriploading(true);
        upadteTripReplaceDriverApi(routeid, { ...tripform,trip_id: tripdata?.id,update_type:'REPLACE_DRIVER' })
          .then(() => {
            setModalopen(false);
            handleListReload();
            toast.success("Trip updated successfully");
          })
          .catch((err) => {
            setTriperrormsg(
              err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Please try again later"
            );
          })
          .finally(() => setCreatettriploading(false));
      }
    }

  // const getTripStartTimeMinRange = () => {
  //   const currentShift = shiftoption.find(
  //     (item) => item.id === selecetdShift?.value
  //   );
  //   if (!currentShift) return;
  //   if (tripmode === "PICKUP") {
  //     return currentShift?.start_time;
  //   } else {
  //     return currentShift?.drop_start_time;
  //   }
  // };

  // const getTripStartTimeMaxRange = () => {
  //   const currentShift = shiftoption.find(
  //     (item) => item.id === selecetdShift?.value
  //   );
  //   if (!currentShift) return;
  //   if (tripmode === "PICKUP") {
  //     return currentShift?.end_time;
  //   } else {
  //     return currentShift?.drop_end_time;
  //   }
  // };
  // useEffect(() => {
  //   if (selecetdShift && tripmode) {
  //     const min = getTripStartTimeMinRange();
  //     const max = getTripStartTimeMaxRange();
  //     setTimemsg(`(${formatTo12Hour(min)} - ${formatTo12Hour(max)})`);
  //   } else {
  //     setTimemsg("");
  //   }
  // }, [selecetdShift, tripmode]);
  return (
    <Modal
      show={modalopen}
      onHide={() => setModalopen(false)}
      dialogClassName="modal-top"
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>Replace Driver</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          {triperrormsg && (
            <div className="alert alert-danger">{triperrormsg}</div>
          )}

          {/* <div className="d-flex gap-2">
            <div className="w-50">
              <label className="form-label">Trip Mode</label>
              <div className="d-flex gap-4">
                {["PICKUP", "DROP"].map((mode) => (
                  <div className="form-check" key={mode}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="routeType"
                      disabled
                      value={mode}
                      id={`${mode.toLowerCase()}Radio`}
                      checked={tripmode === mode}
                      onChange={(e) => {
                        setTripmode(e.target.value);
                        settripform({ ...tripform, trip_mode: e.target.value });
                        setStarttime("");
                        setEndtime("");
                        setTriperrormsg("");
                        setTimeConfirmed(false);
                      }}
                    />
                    <label
                      className="form-check-label text-secondary"
                      style={{ fontWeight: "500" }}
                    >
                      {mode.charAt(0) + mode.slice(1).toLowerCase()}
                    </label>
                  </div>
                ))}
              </div>
              {errorform?.trip_mode && (
                <small className="text-danger">{errorform.trip_mode}</small>
              )}
            </div>

            <div className="w-50">
              <label className="form-label">Select Shift</label>
              <Select
                isDisabled
                options={shiftoption.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                onChange={(selected) => {
                  setSelectedShift(selected);
                  setStarttime("");
                  setEndtime("");
                  setTriperrormsg("");
                  setTimeConfirmed(false);
                }}
                className="react-select"
                classNamePrefix="select"
                placeholder="Shift"
                isClearable
                value={selecetdShift}
              />
              {errorform?.shift_id && (
                <small className="text-danger">{errorform.shift_id}</small>
              )}
            </div>
          </div>

          <div className="d-flex gap-2 mt-2">
            <div className="w-50">
              <label className="form-label">Start Time {timemsg}</label>
              <input
                readOnly
                disabled
                type="time"
                className="form-control"
                value={starttime}
                min={getTripStartTimeMinRange()}
                max={getTripStartTimeMaxRange()}
                // disabled={!tripmode || !selecetdShift}
                onChange={(e) => {
                  const value = e.target.value;
                  setStarttime(value); // Just update time on change
                  setTimeConfirmed(false); // mark as unconfirmed
                }}
                onBlur={() => {
                  const min = getTripStartTimeMinRange();
                  const max = getTripStartTimeMaxRange();

                  if (!isTimeWithinRange(starttime, min, max)) {
                    setTriperrormsg(
                      `Start time must be between ${formatTo12Hour(
                        min
                      )} and ${formatTo12Hour(max)}`
                    );
                    setStarttime("");
                    setEndtime("");
                    return;
                  } else {
                    setTriperrormsg("");
                    setEndtime(
                      addMinutes(starttime, parseFloat(end_time || "0"))
                    );
                  }

                  if (starttime) setTimeConfirmed(true);
                }}
              />
              {errorform?.start_time && (
                <small className="text-danger">{errorform.start_time}</small>
              )}
            </div>

            <div className="w-50">
              <label className="form-label">End Time</label>
              <input
                type="time"
                className="form-control"
                value={endtime}
                readOnly
                disabled
              />
            </div>
          </div>

          {optionloading && (
            <div className="d-flex justify-content-center align-items-center mt-3">
              <Spinner animation="border" size="sm" />
              <span className="ms-2">Loading...</span>
            </div>
          )}

          {showoption && !optionloading && (
            <div className="d-flex gap-2 mt-1">
              <div className="w-50">
                <label className="form-label">Select Bus</label>
                <Select
                  isDisabled
                  options={busoption}
                  onChange={setSelectedbus}
                  placeholder="Bus"
                  isClearable
                  value={selectedBus}
                  className="react-select"
                  classNamePrefix="select"
                />
                {errorform?.bus_id && (
                  <small className="text-danger">{errorform.bus_id}</small>
                )}
              </div>

              <div className="w-50">
                <label className="form-label">Select New Driver</label>
                <Select
                  options={driveroption}
                  onChange={(selected) => {
                    setSelecteddriver(selected);
                    if (selected?.value) {
                      setErrorform({ ...errorform, driver_id: "" });
                    }
                  }}
                  placeholder="Driver"
                  isClearable
                  className="react-select"
                  classNamePrefix="select"
                  value={selecteddriver}
                />
                {errorform?.driver_id && (
                  <small className="text-danger">{errorform.driver_id}</small>
                )}
              </div>
            </div>
          )} */}
            <div>
              <label className="form-label">Select New Driver</label>
              <Select
                options={driveroption}
                onChange={(selected) => {
                  setSelecteddriver(selected);
                  if (selected?.value) {
                    setErrorform({ ...errorform, driver_id: "" });
                  }
                }}
                placeholder="Driver"
                isClearable
                className="react-select"
                classNamePrefix="select"
                value={selecteddriver}
                isLoading={optionloading}
              />
              {errorform?.driver_id && (
                <small className="text-danger">{errorform.driver_id}</small>
              )}
            </div>
          <div>
          
          </div>
          {/* <div className="mt-2">
            <label className="form-label">Status</label>
            <div className="d-flex gap-2">
              {["Maintenance", "Breakdown", "Other"].map((mode) => (
                <div className="form-check" key={mode}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="status"
                    value={mode}
                    id={`${mode.toLowerCase()}Radio`}
                    checked={status === mode}
                    onChange={(e) => {
                      setStatus(e.target.value);
                      settripform((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }));
                      if (e.target.value) {
                        setErrorform({ ...errorform, status: "" });
                      }
                    }}
                  />
                  <label
                    htmlFor={`${mode.toLowerCase()}Radio`} // Proper linking
                    className="form-check-label text-secondary"
                    style={{ fontWeight: "500" }}
                  >
                    {mode}
                  </label>
                </div>
              ))}
            </div>
            {errorform?.status && (
              <small className="text-danger">{errorform.status}</small>
            )}
          </div>
          <div className="my-2">
            <label htmlFor="reason" className="form-label fw-semibold">
              Description
            </label>
            <textarea
              id="reason"
              className="form-control"
              rows="2"
              value={tripform.description}
              onChange={(e) => {
                settripform({ ...tripform, description: e.target.value });
                if (e.target.value) {
                  setErrorform({ ...errorform, description: "" });
                }
              }}
              placeholder="Enter your reason or description..."
            ></textarea>
            {errorform?.description && (
              <small className="text-danger">{errorform.description}</small>
            )}
          </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 justify-content-center gap-2">
          <button
            className="btn btn-outline-secondary"
            onClick={() => setModalopen(false)}
            disabled={createtriploading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handletripform}
            disabled={createtriploading}
          >
            {createtriploading && <Spinner animation="border" size="sm" />}{" "}
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ReplaceDriverModal;
